import { useState } from 'react'
import ReactPlayer from 'react-player/lazy'
import Image from 'next/image'

interface Props {
  url: string
  isBlog?: boolean
  autoplay?: boolean
  thumbnail?: string
}

const DemoVideo = ({
  url,
  isBlog,
  autoplay,
  thumbnail,
}: Props): JSX.Element => {
  const [playing, setPlaying] = useState(autoplay || false)

  return (
    <div
      className={
        'mx-auto relative overflow-hidden rounded-xl bg-white max-h-[80vh] ' +
        (isBlog ? 'lg:shadow-xl shadow-small' : 'shadow-big')
      }
      style={{
        aspectRatio: '16 / 9',
      }}
    >
      {playing ? (
        <ReactPlayer
          url={url}
          className='absolute top-0 left-0 w-full h-full rounded-xl'
          playing={playing}
          width='100%'
          height='100%'
          controls
          fallback={<Thumbnail src={thumbnail} />}
        />
      ) : (
        <>
          <div className='absolute top-0 left-0 w-full h-full'>
            <Thumbnail src={thumbnail} />
          </div>

          <button
            className='absolute top-0 left-0 w-full h-full play-btn'
            onClick={() => setPlaying(true)}
            aria-label='Play video'
          >
            <div className='absolute z-20 flex items-center justify-center w-16 h-16 transform -translate-x-1/2 -translate-y-1/2 rounded-full sm:h-20 sm:w-20 top-1/2 left-1/2 focus:outline-none'>
              <div className='absolute top-0 bottom-0 left-0 right-0 z-0 border rounded-full border-blue bg-blue play-btn-bg ring-8 ring-blue-60' />

              <svg
                xmlns='http://www.w3.org/2000/svg'
                className='relative w-8 h-8 sm:w-10 sm:h-10 play-btn-icon'
                fill='none'
                viewBox='0 0 24 24'
              >
                <path
                  fill='#fff'
                  stroke='#fff'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='2'
                  d='M7 4v16l13-8L7 4z'
                ></path>
              </svg>
            </div>
          </button>
        </>
      )}
    </div>
  )
}

export default DemoVideo

const Thumbnail = ({ src }) => (
  <div className='relative h-full w-full'>
    <Image
      alt='Demo video thumbnail'
      src={src}
      fill
      className='bg-white'
      style={{ objectFit: 'cover', objectPosition: 'top' }}
    />
  </div>
)
